<template>
  <div class="content">
    <div class="header">
      <div class="left">
        以下商品可用 <span class="coupon-type">{{ getCouponType }}</span>
      </div>
      <div
        class="right"
        @click="categoryShow = true"
        v-if="couponInfo.coupon?.is_all_goods === 1"
      >
        {{ currentCategory.category_name || "筛选" }}
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="item in list" :key="item">
        <div class="left">
          <van-image fit="cover" :src="item.goods_cover_image"> </van-image>
        </div>
        <div class="right">
          <div class="top">
            <p class="title">{{ item.goods_subtitle }}</p>
            <p class="subhead">{{ item.goods_name }}</p>
          </div>
          <div class="bottom">
            <div class="num fa fa-heart">
              {{ item.goods_vr_sale_count }}人测过
            </div>
            <div class="right-button" @click="handleItem(item)">
              {{ couponInfo.coupon_type === 2 ? "立即赠送" : "立即使用" }}
            </div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <van-loading v-show="loading" size="18px">加载中...</van-loading>
        <div class="none" v-show="nomore">没有更多数据了</div>
      </div>
    </div>
  </div>

  <van-dialog
    v-model:show="confirmShow"
    title="请问你是否选择赠送"
    show-cancel-button
    @confirm="handleGive"
  >
    <div class="dialog-content">
      <div class="name">{{ currentItem.goods_name }}</div>
      <div class="tip">请注意：确认赠送后，无法修改或取消</div>
    </div>
  </van-dialog>

  <van-popup position="bottom" round v-model:show="categoryShow">
    <van-picker
      :columns="categoryList"
      :loading="categoryLoading"
      :columns-field-names="{
        text: 'category_name',
      }"
      @confirm="handleCategoryConfirm"
    />
  </van-popup>

  <WeChatQr v-model:show="wechatQrVisible" title="请关注公众号">
    <span
      >【赠送券】需要在微信内使用，请关注公众号后，进入我的优惠券，继续下一步操作</span
    >
  </WeChatQr>
</template>

<script setup>
import { onMounted, ref, reactive, computed } from "vue";
import { userCoupondetail, sendGoods } from "@/api/coupon";
import { getCategoryList } from "@/api/category";
import { useRoute } from "vue-router";
import { useCreateOrder } from "./useCreateOrder";
import { useScrollBottom } from "@/hooks/useScroll";
import { useAgent } from "@/hooks/useAgent";
import { useRouter } from "vue-router";
import WeChatQr from "@/components/WeChatQr";
import { Dialog } from "vant";

const router = useRouter();
const { isWeChat } = useAgent();
const route = useRoute();
const { coupon_code } = route.query;
const loading = ref(false);
const nomore = ref(false);

const list = ref([]);
const categoryList = ref([]);
const confirmShow = ref(false);
const categoryShow = ref(false);
const categoryLoading = ref(false);
const currentCategory = ref({});
const currentItem = ref({});
const wechatQrVisible = ref(false);
const query = reactive({
  page: 1,
  limit: 10,
  category_id: 0,
  coupon_code,
});
const couponInfo = ref({});

const getCouponType = computed(() => {
  // 1=现金券,2=赠送券,3=折扣券,4=VIP折扣券
  return {
    1: "现金券",
    2: "赠送券",
    3: "折扣券",
    // 4: "VIP折扣券",
  }[couponInfo.value.coupon_type];
});

onMounted(() => {
  getList();
  getCategorys();
});

function handleCategoryConfirm(value) {
  currentCategory.value = value;
  query.category_id = value.id;
  query.page = 1;
  nomore.value = false;
  list.value = [];
  getList();
  categoryShow.value = false;
}
async function getCategorys() {
  try {
    categoryLoading.value = true;
    const { data } = await getCategoryList();
    categoryList.value = data;
  } finally {
    categoryLoading.value = false;
  }
}
const { createExamOrder } = useCreateOrder();
function handleItem(item) {
  // 赠送券
  if (couponInfo.value.coupon_type === 2) {
    if (!isWeChat) {
      wechatQrVisible.value = true;
      return;
    }

    confirmShow.value = true;
    currentItem.value = { ...item };
  } else {
    // 立即测试
    // createExamOrder({ goodsInfo: item, couponInfo });
    router.push({
      path: "/goods",
      query: {
        guid: item.guid,
        coupon_code: couponInfo.value.code,
      },
    });
  }
}
async function handleGive() {
  const {
    data: { send_code },
  } = await sendGoods({
    coupon_code: couponInfo.value.code,
    guid: currentItem.value.guid,
  });
  router.push({
    path: "/giveDetail",
    query: {
      send_code,
    },
  });
}
//滚动事件
useScrollBottom(() => {
  if (nomore.value) return;
  query.page++;
  getList();
}, 100);
// 获取商品列表
async function getList() {
  try {
    if (nomore.value) return;
    loading.value = true;
    const {
      data: { goodsList, userCouponInfo },
    } = await userCoupondetail(query);

    if (!goodsList.data.length) {
      nomore.value = true;
    }
    couponInfo.value = userCouponInfo;
    loading.value = false;
    if (userCouponInfo.is_use === 0) {
      list.value = [...list.value, ...goodsList.data];
    } else {
      try {
        await Dialog.alert({
          title: "提示",
          message: "优惠券已使用",
          theme: "round-button",
        });
        router.push("/");
      } catch (error) {}
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style lang="less" scoped>
.dialog-content {
  display: flex;
  align-items: center;
  flex-direction: column;

  .name {
    padding-top: 20px;
    font-weight: bold;
    font-size: 16px;
  }

  .tip {
    font-size: 12px;
    color: #d43030;
    padding: 20px 0;
  }
}

.content {
  padding-top: 50px;

  .header {
    background-color: #ededed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    font-size: 16px;
    padding: 0 10px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background-color: #ededed;
    z-index: 999;
    @media screen and (min-width: @max-device-width) {
      width: @max-device-width;
    }
    .left {
      .coupon-type {
        color: #ff5d7d;
      }
    }

    .right {
      color: #656565;
    }
  }

  .list {
    background-color: #f9f9f9;
    padding-top: 10px;

    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: @padding-sm 0;

      .none {
        color: #969799;
        font-size: @font-size-base;
      }
    }

    .item {
      padding: @padding-base @padding-sm;
      .pointer();
      .space-between();

      .left {
        width: 90px;
        height: 90px;

        .van-image {
          width: 100%;
          height: 100%;

          :deep(img) {
            border-radius: @radius-base;
          }
        }
      }

      .right {
        flex: 1;
        padding-left: @padding-sm;
        .column-space-between();

        .right-button {
          width: 90px;
          height: 26px;
          line-height: 26px;
          border-radius: 26px;
          padding: 0 @padding-base;
          background-color: @theme-color;
          color: #fff;
          font-size: @font-size-base;
        }

        .top {
          .title {
            font-weight: bold;
            font-size: @font-size-lg;
          }

          .subhead {
            color: @gray-color;
            font-size: @font-size-base;
          }
        }

        .bottom {
          font-size: @font-size-base;
          width: 100%;

          .space-between();

          .num {
            line-height: 26px;
            color: @gray-color;

            &::before {
              color: @theme-color;
            }
          }
        }
      }
    }
  }
}
</style>
